import logo from '@assets/logo.png';
import RealAuthenticationLogo from '@assets/brand_real authentication.png';
import { realAuthenticationMerchantID, COBRANDING_LOGO } from '@constants';
import help from '@/assets/help.svg';
import { useLanguage } from '@/hooks/use-language';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import classes from './index.module.css';

// 上传cobranding logo时候需要按照统一格式上传，后续不需要再增加cobranding map
const getCoBrandingLogo = (platform, merchantId) => {
  if (realAuthenticationMerchantID.includes(merchantId)) {
    return RealAuthenticationLogo;
  }
  return COBRANDING_LOGO[platform] || `https://cdn.seel.com/assets/images/cobranding_${platform}.png`;
};

export const Navigation = ({ platform, merchantId }) => {
  const { t } = useTranslation();
  const { langSelectCom } = useLanguage();
  const TITLE_TEXT = langSelectCom ? t('Resolution Center') : 'Resolution Center';
  const [centerLogo, setCenterLogo] = useState(getCoBrandingLogo(platform, merchantId));

  return (
    <nav className={classes.navigationBar}>
      <section className={classes.left}>
        {
          !centerLogo && (
            <section className={`${classes.logo}`}>
              <img src={logo} className={classes.logoIcon} alt="" />
            </section>
          )
        }
        {centerLogo && (
          <section className={`${classes.hidden} ${classes.mdShowFlex}`}>
            <img src={logo} className={classes.logoIcon} alt="" />
          </section>
        )}

        <section className={`${classes.title} ${centerLogo ? classes.real_auth_title : ''}`}>
          {TITLE_TEXT}
        </section>

      </section>
      {
        centerLogo
        && (
          <section className={`${classes.right} ${classes.mdHidden} ${centerLogo ? classes.real_auth : ''}`}>
            <img
              src={centerLogo}
              alt=""
              className={`${classes.platform_logo} ${centerLogo ? classes.real_auth_logo : ''}`}
              onError={() => {
                setCenterLogo('');
              }}
            />
          </section>
        )
      }
      <div className={classes.lang_wrapper}>
        <div>{langSelectCom}</div>
        <div>
          <a
            className={classes.help_content}
            href="https://kover2618.zendesk.com/hc/en-us/categories/8621004064155-Shoppers"
            rel="noreferrer"
            target="_blank"
          >
            <img alt="help" src={help} />
            {langSelectCom ? t('Help') : 'Help'}
          </a>
        </div>
      </div>
    </nav>
  );
};
